import React, {
    useState,
    useEffect
  } from "react";
  import {
    Box,
    Button,
    Container,
    FormLabel,
    Typography
  } from "@material-ui/core";
  import { borderRadius } from "@mui/system";
  import { border } from "@mui/system";
  import { useHistory } from "react-router-dom";
  import {connect, useDispatch, useSelector} from "react-redux";
  import {IUser} from "../../common";
  import { makeStyles } from '@material-ui/core/styles';
  import NotesIcon from '@material-ui/icons/Notes';
  import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
  import PersonalVideoIcon from '@material-ui/icons/PersonalVideo';
  import { userService } from "../../services";
  
  interface Props {
    user: IUser,
    loading: boolean
  }
  
  const useStyles = makeStyles((theme) => ({ 
      title: {
        fontSize: 36,
        fontWeight: 800,
        color:'#273878',
        marginBottom: 16,
        fontFamily: "Bogart Regular"
      },
      subTitle: {
        fontSize: 24,
        fontWeight: 600,
        color:'#273878',
        marginTop: 16,
        fontFamily: "Bogart Regular" ,
        marginLeft: 5
      },
      detailText: {
          fontSize: 20,
          fontWeight: 500,
          marginTop: 12,
          marginBottom: 16,
          marginLeft: 10,
          color:'#273878'
        },
      container: {
        marginTop: 50
      }
    }));
  
  export const NotificationLinksPage = (props: Props) => {
    const [lastName, setLastName] = useState("");
    const classes = useStyles();
    const history = useHistory();
    const [checkboxChecked, setCheckboxChecked] = useState(false);  
    const greeting = (lastName === "") ? "Welcome" : "Welcome, Dr. ";
  
    useEffect(() => {
      const userData = JSON.parse(localStorage.getItem("user_data") || "{}");
      if (userData && userData.userId) {
        userService.getProfileById(userData.userId)
          .then((resp) => {
            const data = resp[0];
            setLastName(data.lastName);
          }).catch((err) => {
            // TODO handle errors properly, show alert or something of the like
            console.error(err);
          });
      }
    },[]);
  
    return (
            (
                <Container className={classes.container}>
                  <FormLabel className={classes.title}>{greeting}{lastName}!</FormLabel>
                  <Box
                      display="flex"
                      flexDirection="column"
                      flexWrap="wrap"
                      width="70%"
                      marginBottom="16px"
                      marginTop="16px"
                      border={1} 
                      borderColor="#f1f1f1"
                      bgcolor="#f1f1f1"
                      borderRadius={10}
                  >
                  <FormLabel className={classes.subTitle}>Reminders and Updates:</FormLabel>
                  <FormLabel className={classes.detailText}>
                  1. Pre-wellness appointments will say “This is a pre-wellness appointment for (Clinic Name)” but this appointment is for you.
                  </FormLabel>
                  <FormLabel className={classes.detailText}>
                  2. For pre-wellness appointments, please don’t forget to record the date of the in-person wellness appointment in the Plan section. 
                  </FormLabel>
                  </Box>
                  <FormLabel className={classes.subTitle}>Quick-Access Links:</FormLabel>
                  <Box
                      display="flex"
                      justifyContent="flex-start"
                      flexDirection="column"
                      alignItems="flex-start"
                      flexWrap="wrap"
                      width="100%"
                      marginBottom="16px"
                      marginTop="16px"
                  >
                  <Button target="_blank" href="https://app.helloralphie.com/appointments" rel="noreferrer" id='access-appts' startIcon={<PersonalVideoIcon/>}>
                      View and Access Appointments
                  </Button>
                  <Button target="_blank" href="https://app.getsling.com" rel="noreferrer" id='request-shifts' startIcon={<CalendarTodayIcon/>}>
                      View and Request Shifts
                  </Button>
                  <Button target="_blank" href="https://docs.google.com/document/d/1mbYRUqmEM2Bz01x5DgSLU7nmO6N4Cjj2XhwNlJEzGQg/edit?usp=sharing" rel="noreferrer" id='pre-wellness-guidelines' startIcon={<NotesIcon/>}>
                      Pre-Wellness Guidelines 
                  </Button>
                  {/* TODO: once handouts are ready 
                  <Button id='handouts' startIcon={<NotesIcon/>}>
                      Handouts For Clients
                  </Button> */}
                  </Box>
                </Container>
            )
    );
  }; 

  export default NotificationLinksPage;